import createLucideIcon from '../createLucideIcon';

const Briefcase = createLucideIcon('BriefcaseIcon', [
  [
    'rect',
    {
      x: '2',
      y: '7',
      width: '20',
      height: '14',
      rx: '2',
      ry: '2',
      key: '1fj28a',
    },
  ],
  ['path', { d: 'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16', key: 'zwj3tp' }],
]);

export default Briefcase;
